export const INSUFFICIENT_CREDITS_ERROR_CODE = 'insufficient_funds';
